import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractAccountOperation from "./AbstractAccountOperation.js";

/**
 * Period change sums all transactions in the context period.
 */
export default class PeriodChangeAccountOperation extends AbstractAccountOperation {
	getName() {
		return _("Period");
	}

	getShortName() {
		return _("Period");
	}

	static getType() {
		return "PeriodChangeAccountOperation";
	}

	static getOperationType() {
		return "Change";
	}
}
